import type { MaterialsItem } from "@/lib/materials-api";
import { classifyFileType } from "@/lib/materials-filters";
import { isExternalVideoItem } from "@/lib/materials-external-video";

/** 素材库预览形态：图片 / Markdown / 视频 / 音频 / 其余仅元数据。 */
export type PreviewKind = "image" | "markdown" | "video" | "audio" | "other";

/** 预览分类优先识别外链视频与音视频，再复用现有图片/Markdown 判定。 */
export function previewKind(item: MaterialsItem): PreviewKind {
  if (isExternalVideoItem(item)) return "video";

  const name = item.name.toLowerCase();
  const ct = (item.content_type ?? "").toLowerCase();
  if (
    ct.startsWith("video/") ||
    /\.(mp4|mov|webm|m4v|avi|mkv)$/i.test(name)
  ) {
    return "video";
  }
  if (
    ct.startsWith("audio/") ||
    /\.(mp3|m4a|wav|ogg|flac|aac)$/i.test(name)
  ) {
    return "audio";
  }

  const facet = classifyFileType(item);
  if (facet === "image") return "image";
  if (facet === "markdown") return "markdown";
  return "other";
}

export function previewKindLabel(kind: PreviewKind): string {
  if (kind === "image") return "图片";
  if (kind === "markdown") return "Markdown";
  if (kind === "video") return "视频";
  if (kind === "audio") return "音频";
  return "文件";
}
